<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
      <simple-wizard :is-modal="isModal" :is-edit="isEdit" :go-next="goNext" @close="handleClose">
        <template slot="header">
          <!-- <h3 class="title" style="line-height: 12px">Register With GlobeChek</h3> -->
          <h5 class="category">
            <span style="font-weight: 500; color: #1f5aff">Globe</span>
            <span style="font-weight: 700; color: #555">Chek</span>&nbsp;
            <span style="font-weight: 400; color: 222">
              {{ isEdit ? "Edit Doctor Details" : "Doctor Registration" }}
            </span>
            <hr style="margin-top: 20px" />
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            Step 1
            <!--Personal-->
            <!-- If is modal the its was called by the admin panel -->
          </template>
          <first-step ref="step1" :is-admin-panel="isModal" :is-edit="isEdit" @on-validated="onStepValidated"
            @complete="nextTab" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            Step 2
            <!--Credentials-->
          </template>
          <second-step ref="step2" :is-edit="isEdit" @on-validated="onStepValidated" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">
            Step 3
            <!-- Practice -->
          </template>
          <third-step ref="step3" :is-edit="isEdit" @on-validated="onStepValidated" />
        </wizard-tab>

        <wizard-tab v-if="!isEdit && !isAdmin" :before-change="() => validateStep('step4')">
          <template slot="label"> Notes </template>
          <fourth-step ref="step4" :is-edit="isEdit" @on-validated="onStepValidated" @complete="nextTab" />
        </wizard-tab>

        <wizard-tab v-if="!isEdit && !isAdmin" :before-change="() => validateStep('step5')">
          <template slot="label"> Last </template>
          <fifth-step ref="step5" @on-validated="wizardComplete" />
        </wizard-tab>

        <!-- Final step for edition flow or if admin/super -->
        <wizard-tab v-if="isEdit || isAdmin" :before-change="() => validateStep('step4')">
          <template slot="label"> Notes </template>
          <fourth-step ref="step4" :is-edit="isEdit" @on-validated="wizardComplete" />
        </wizard-tab>
      </simple-wizard>
    </div>
    <loader :is-visible="isLoading" />
    <ChooseOrganizationModal v-if="isOrganizationModalOpen" :is-open="isOrganizationModalOpen"
      @cancel="closeOrganizationModal" @save="handleOrganizationSelected" />
  </div>
</template>
<script>
import FirstStep from "./Wizard/Doctor_Registration/2_PersonalStep.vue" //"./Wizard/1_WelcomeStep.vue";
import SecondStep from "./Wizard/Doctor_Registration/3_CredentialsStep.vue"
import ThirdStep from "./Wizard/Doctor_Registration/4_PracticeStep"
import FourthStep from "./Wizard/Doctor_Registration/5_CommentsStep"
import FifthStep from "./Wizard/Doctor_Registration/6_FinalStep"
import { SimpleWizard, WizardTab } from "@/components"
import loader from "@/components/GlobeChek/loader.vue"
import Swal from "sweetalert2"
import { mapGetters } from "vuex"
import ChooseOrganizationModal from "@/components/modals/ChooseOrgModal.vue"
export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    SimpleWizard,
    WizardTab,
    loader,
    ChooseOrganizationModal
  },
  props: {
    doctor: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wizardModel: {},
      defaultDoctorStatus: 2,
      goNext: false,
      isLoading: false,
      isOrganizationModalOpen: false,
      selectedOrganization: null,
      isAdmin: (sessionStorage.getItem("usertype") == "Super" || sessionStorage.getItem("usertype") === 'Administrator')
    }
  },
  watch: {
    isEdit(newVal) {
      if (newVal) {
        this.fillPracticeData()
      }
    }
  },
  computed: {
    ...mapGetters(["doctorReg", "drEditInfo"]),
    isPhone() {
      if (window.screen.width < 760) {
        return true
      } else {
        return false
      }
    },
    screenWidth() {
      return window.screen.width
    }
  },
  methods: {
    nextTab() {
      this.goNext = true
      this.$nextTick(() => {
        this.goNext = false
      })
    },
    validateStep(ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model }
    },
    formatCertificationDate(dateString) {
      if (!dateString) return null
      return `${dateString} 00:00:00`
    },
    defineDoctorCreatePayload() {
      const orgIds = this.selectedOrganization

      const payload = {
        qualification: this.doctorReg.Credentials.qualification,
        boardCertificate: this.doctorReg.Credentials.ruCertified,
        speciality: this.doctorReg.Credentials.specialties || undefined,
        specialization: this.doctorReg.Credentials.specialization || undefined,
        subspecialization: this.doctorReg.Credentials.subSpecialization || undefined,
        caqh: this.doctorReg.Credentials.CAQH || "",
        npi: this.doctorReg.Credentials.NPI || "",
        license: this.doctorReg.Credentials.LICENSE || "",
        insurance: this.doctorReg.Practice.insurances.toString() || "",
        otherInsurance: "",
        status: 2,
        practice: this.doctorReg.Practice.bizName || "",
        webSite: this.doctorReg.Practice.website || "",
        businessPhoneNo: this.doctorReg.Practice.phone || "",
        isReader: this.doctorReg.Personal.isReader || false,
        userType: "Doctor",
        userId: null,
        isApproved: false,
        regions: [796],
        organisations: orgIds,
        mailingAddress: {
          id: this.doctorReg.Personal.mainAddressID || "",
          address1: this.doctorReg.Personal.address1 || "",
          address2: "",
          city: this.doctorReg.Personal.city || "",
          state: this.doctorReg.Personal.state || "",
          country: this.doctorReg.Personal.country || "",
          zipCode: this.doctorReg.Personal.zipCode || "",
          addressType: 1
        },
        businessAddress: {
          id: "",
          address1: this.doctorReg.Practice.address || "",
          address2: "",
          city: this.doctorReg.Practice.city || "",
          state: this.doctorReg.Practice.state || "",
          country: this.doctorReg.Practice.country || "",
          zipCode: this.doctorReg.Practice.zip || "",
          addressType: 2
        },
        person: {
          id: "",
          firstName: this.doctorReg.Personal.firstName || "",
          lastName: this.doctorReg.Personal.lastName || "",
          title: this.doctorReg.Personal.title || "",
          email: this.doctorReg.Personal.emailAddress || "",
          cellNumber: this.doctorReg.Personal.cellNumber || "",
          allowSMS: this.doctorReg.Personal.allowSMS || false,
          gender: this.doctorReg.Personal.gender || "",
          comments: this.doctorReg.Comments.comments || "",
          languages: this.doctorReg.Practice.languages.toString() || "",
          status: 2
        }
      }
      if (this.doctorReg.Credentials.certDate && this.doctorReg.Credentials.ruCertified === "Yes") {
        payload.certificationDate = this.formatCertificationDate(this.doctorReg.Credentials.certDate)
      }

      return payload
    },
    defineDoctorEditPayload() {
      const isMultipleOrgs = this.drEditInfo.organisations.includes(";")
      if (isMultipleOrgs) {
        this.drEditInfo.organisations = this.drEditInfo.organisations.split(";")
      }
      if (!isMultipleOrgs) {
        if (!Array.isArray(this.drEditInfo.organisations)) {
          this.drEditInfo.organisations = [this.drEditInfo.organisations]
        }
      }
      const payload = {
        id: this.drEditInfo.id,
        personID: this.drEditInfo.personID,
        speciality: this.doctorReg.Credentials.specialties.toString(),
        specialization: this.doctorReg.Credentials.specialization.toString(),
        subspecialization: this.doctorReg.Credentials.subSpecialization.toString(),
        qualification: this.doctorReg.Credentials.qualification,
        boardCertificate: this.doctorReg.Credentials.ruCertified,
        CAQH: this.doctorReg.Credentials.CAQH,
        NPI: this.doctorReg.Credentials.NPI,
        license: this.doctorReg.Credentials.LICENSE,
        insurance: this.doctorReg.Practice.insurances.toString(),
        status: this.defaultDoctorStatus,
        practice: this.doctorReg.Practice.bizName,
        webSite: this.doctorReg.Practice.website,
        certificationDate: this.formatCertificationDate(this.doctorReg.Credentials.certDate),
        businessPhoneNo: this.doctorReg.Practice.phone,
        isReader: this.doctorReg.Personal.isReader || false,
        userType: "Doctor",
        isApproved: false,
        isAccountCreated: false,
        organisations: this.drEditInfo.organisations,
        regions: this.drEditInfo.regions ? this.drEditInfo.regions : [796],
        mailingAddress: {
          id: this.doctorReg.Personal.mainAddressID || "",
          address1: this.doctorReg.Personal.address1 || "",
          address2: this.doctorReg.Personal.address2 || "",
          city: this.doctorReg.Personal.city || "",
          state: this.doctorReg.Personal.state.toString() || "",
          country: this.doctorReg.Personal.country.toString() || "",
          zipCode: this.doctorReg.Personal.zipCode || "",
          addressType: 1
        },
        businessAddress: {
          id: this.doctorReg.Practice.workAddressId || "",
          address1: this.doctorReg.Practice.address || "",
          address2: "",
          city: this.doctorReg.Practice.city || "",
          state: this.doctorReg.Practice.state.toString() || "",
          country: this.doctorReg.Practice.country.toString() || "",
          zipCode: this.doctorReg.Practice.zip || "",
          addressType: 2
        },
        person: {
          id: this.doctorReg.EditInfo.personID || "",
          firstName: this.doctorReg.Personal.firstName || "",
          lastName: this.doctorReg.Personal.lastName || "",
          title: this.doctorReg.Personal.title || "",
          email: this.doctorReg.Personal.emailAddress || "",
          cellNumber: this.doctorReg.Personal.cellNumber || "",
          allowSMS: this.doctorReg.Personal.allowSMS,
          gender: this.doctorReg.Personal.gender || "",
          DOB: null,
          comments: this.doctorReg.Comments.comments || "",
          languages: this.doctorReg.Practice.languages.toString() || "",
          status: 2
        }
      }
      return payload
    },
    async notifyAdmin() {
      var vm = this
      var msg = `
          A Doctor Enrollment has been requested by: &nbsp&nbsp <b><u>${this.doctorReg.Personal.firstName} ${this.doctorReg.Personal.lastName}</u></b><br>
          Here is the FORM DATA submitted:<br>

          <h3>Personal Info:</h3>
          <ul>
              <li><u>First Name:</u>&nbsp         <b>${this.doctorReg.Personal.firstName}</b>      </li>
              <li><u>Last Name:</u>&nbsp          <b>${this.doctorReg.Personal.lastName}</b>       </li>
              <li><u>Email Address:</u>&nbsp      <b>${this.doctorReg.Personal.emailAddress}</b>   </li>
              <li><u>Cell Number:</u>&nbsp        <b>${this.doctorReg.Personal.cellNumber}</b>     </li>
              <li><u>Allow SMS ?:</u>&nbsp        <b>${this.doctorReg.Personal.allowSMS}</b>       </li>
          </ul><br>

          <h3>Qualifications:</h3>
          <ul>
              <li><u>Qualificaiton:</u>&nbsp      <b>${this.doctorReg.Credentials.qualification}</b></li>
              <li><u>Specialization:</u>&nbsp     <b>${this.doctorReg.Credentials.specialization}</b></li>
              <li><u>SubSpecialization:</u>&nbsp  <b>${this.doctorReg.Credentials.subSpecialization}</b></li>
              <li><u>Specialties:</u>&nbsp        <b>${this.doctorReg.Credentials.specialties}</b></li>
              <li><u>Is Certified?:</u>&nbsp      <b>${this.doctorReg.Credentials.ruCertified}</b></li>
              <li><u>CertDate:</u>&nbsp           <b>${this.doctorReg.Credentials.certDate}</b></li>
              <li><u>CAQH:</u>&nbsp               <b>${this.doctorReg.Credentials.CAQH}</b></li>
              <li><u>NPI:</u>&nbsp                <b>${this.doctorReg.Credentials.NPI}</b></li>
              <li><u>LICENSE:</u>&nbsp            <b>${this.doctorReg.Credentials.LICENSE}</b></li>
              <li><u>Image File:</u>&nbsp         <b>n/a</b></li>
          </ul><br>

          <h3>Practice Info:</h3>
          <ul>
              <li><u>Practctice:</u>&nbsp         <b>${this.doctorReg.Practice.bizName}</b></li>
              <li><u>Address:</u>&nbsp            <b>${this.doctorReg.Practice.address}</b></li>
              <li><u>City:</u>&nbsp               <b>${this.doctorReg.Practice.city}</b></li>
              <li><u>State:</u>&nbsp              <b>${this.doctorReg.Practice.state}</b></li>
              <li><u>Zip:</u>&nbsp                <b>${this.doctorReg.Practice.zip}</b></li>
              <li><u>Phone:</u>&nbsp              <b>${this.doctorReg.Practice.phone}</b></li>
              <li><u>Country:</u>&nbsp            <b>${this.doctorReg.Practice.country}</b></li>
              <li><u>Website:</u>&nbsp            <b>${this.doctorReg.Practice.website}</b></li>
              <li><u>Languages:</u>&nbsp          <b>${this.doctorReg.Practice.languages}</b></li>
              <li><u>Insurance:</u>&nbsp          <b>${this.doctorReg.Practice.insurances}</b></li>
          </ul><br>

          <h3>Comments:</h3>
          ${this.doctorReg.Comments.comments}<br>
          </hr>
          --END--
          `

      const config = { headers: { "Content-Type": "application/json" } }
      const url = process.env.VUE_APP_URL + "/msg/newmessage"
      const data = {
        senderID: "info@globechek.com",
        senderName: "GlobeChek Portal: Dr. Registration",
        recipientID: process.env.VUE_APP_ADMIN_EMAIL, //"chansen@globechek.com",
        recipientName: "GlobeChek Administration",
        msg_subject:
          "Doctor Enrollment Request for: " +
          this.doctorReg.Personal.firstName +
          " " +
          this.doctorReg.Personal.lastName,
        msg_body: msg,
        msg_level: "normal"
      }
      await window.axios.post(url, data, config).catch(function (error) {
        vm.status = "An error occurred: " + error
        alert("Server Error. Please re-submit")
      })
    },
    async saveDoctor() {
      const config = { headers: { "Content-Type": "application/json" } }
      const userId = sessionStorage.getItem("userID")
      const baseUrl = `${process.env.VUE_APP_URL}/doctors/${this.isModal ? "admin/registration" : "registration"}/${this.isModal ? userId : ""
        }`

      try {
        this.isLoading = true
        if (!this.isEdit) {
          const payload = this.defineDoctorCreatePayload()
          await window.axios.post(baseUrl, payload, config)
        }
        if (this.isEdit) {
          const payload = this.defineDoctorEditPayload()
          const url = `${process.env.VUE_APP_URL}/doctors/${userId}/${this.drEditInfo.id}`
          await window.axios.put(url, payload, config)
        }
        // TODO - this is results in a 404 error
        // const mailData = {
        //   sender_address: "Admin@GlobeChek.com",
        //   recipient_address: this.doctorReg.Personal.emailAddress,
        //   recipient_name: this.doctorReg.Personal.firstName
        // }
        // const confirmURL = process.env.VUE_APP_URL + "/confirm-registration"
        // await axios.post(confirmURL, mailData, config)
        // await this.notifyAdmin()

        // 2025-07-01: Adjusted what modal should appear based if user is editing a reader or not
        if (this.isEdit) {
          Swal.fire({
            title: "Success",
            text: "Doctor updated successfully",
            confirmButtonText: "OK"
          }).then(() => {
            this.$emit("close", true)
          })
        } else {
          Swal.fire({
            title: "Thank You!",
            text: "",
            confirmButtonClass: "md-button md-success",
            buttonsStyling: false
          }).then(() => {
            if (!this.isModal) {
              this.$router.push("/login")
            } else {
              this.$emit("close", true)
            }
          })
        }
      } catch (error) {
        console.log(error)
        let errorMsg = "An error occurred while submitting the data to the server, please try again later"
        if (error.response && error.response.data.detail.message) {
          errorMsg = error.response.data.detail.message
        }
        Swal.fire({
          title: "Error",
          text: errorMsg,
          icon: "error",
          confirmButtonText: "OK"
        })
      } finally {
        this.isLoading = false
      }
    },
    wizardComplete() {
      if (this.isEdit) {
        this.selectedOrganization = this.drEditInfo.organisations
        this.saveDoctor()
      } else {
        const orgsData = sessionStorage.getItem("organizations")
        const organizations = JSON.parse(orgsData)
        if (organizations && organizations.length > 1) {
          this.isOrganizationModalOpen = true
          return
        } else if (organizations && organizations.length === 1) {
          this.selectedOrganization = [organizations[0].orgId]
          this.saveDoctor()
        } else {
          let orgId = sessionStorage.getItem("userOrgID")
          if (!orgId || orgId === "null") {
            orgId = JSON.parse(localStorage.getItem("currentOrg")).id
          }
          this.selectedOrganization = [orgId]
          this.saveDoctor()
        }
      }
    },

    handleClose() {
      this.$emit("close", false)
    },
    closeOrganizationModal() {
      this.isOrganizationModalOpen = false
    },
    handleOrganizationSelected(organization) {
      this.selectedOrganization = organization
      this.isOrganizationModalOpen = false

      this.saveDoctor()
    },
  }
}
</script>

<style>
.swal2-container {
  z-index: 10000;
}
</style>
